import { useQuery } from "@tanstack/react-query";
import { userService } from "../services/userService";

export const useUsers = (search?: string) => {
  return useQuery({
    queryKey: ["users", search],
    queryFn: () => userService.getUsers(search),
    enabled: !search || search.length >= 2, // Only fetch if search is empty or has 2+ chars
  });
};
